import React, { useEffect } from 'react';
import { Box, Button, Typography, TextField } from '@mui/material';
import { useDispatch } from 'react-redux';
import useHandleApiResponse from '../../../../../Hooks/useHandleApiResponse';
import { useSelector } from 'react-redux';
import { getLensSyncData, userSync } from '../../../../../redux/features/lensSyncSlice';

export default function UserSyncModal({ user, onClose }) {
  const dispatch = useDispatch();
  const handleApiResponse = useHandleApiResponse();
  const { loading } = useSelector((state) => state.lens);

  // ✅ Hooks must be called unconditionally at the top
  const [name, setName] = React.useState('');
  const [mobile, setMobile] = React.useState('');
  const [email, setEmail] = React.useState('');
  console.log(user);

  useEffect(() => {
    if (user) {
      setName(user.name || '');
      setMobile(user.mobile || '');
      setEmail(user.email || '');
    }
  }, [user]);

  if (!user) return null;

  const handleSync = () => {
    dispatch(userSync({})).then((res) => {
      handleApiResponse(res, {
        onSuccess: () => {
          onClose(true);
        },
        onFailed: () => {
          console.log('User Sync Failed');
        },
      });
    });
  };

  return (
    <Box p={2}>
      <Typography variant="subtitle1" fontWeight={600} mb={2}>
        CRO User Details
      </Typography>

      <TextField
        label="Name"
        value={name}
        InputProps={{ readOnly: true }}
        onChange={(e) => setName(e.target.value)}
        fullWidth
        margin="dense"
      />
      <TextField
        label="Mobile"
        value={mobile}
        InputProps={{ readOnly: true }}
        onChange={(e) => setMobile(e.target.value)}
        fullWidth
        margin="dense"
      />
      <TextField
        label="Email"
        value={email}
        InputProps={{ readOnly: true }}
        onChange={(e) => setEmail(e.target.value)}
        fullWidth
        margin="dense"
      />

      <Box display="flex" justifyContent="flex-end" gap={2} mt={3}>
        <Button onClick={() => onClose(false)}>Cancel</Button>
        <Button variant="contained" onClick={handleSync}>
          Sync
        </Button>
      </Box>
    </Box>
  );
}
